import React from "react";

const GenerateActivationCode = () => {
  return (
    <div>
      <h1>Generate Activation Code</h1>
      <p>This page is accessible to Super Admins (Role 1) and Agents (Role 2).</p>
    </div>
  );
};

export default GenerateActivationCode;